import picomatch from 'picomatch'
import { uniqueId } from 'lodash'

function initFeedbackInjector() {
  const programId = $('#current_user_data').data('program-id')

  SOPHIA.ajax({
    data: {
      program_id: programId
    },
    dataType: 'json',
    method: 'GET',
    url: '/api/feedback_injections'
  }).then(response => {
    setFeedbackData(response, programId)
  })
}

function setFeedbackData(response, programId) {
  const currentPath = window.location.pathname
  const feedbacks = response          // array of feedbacks
  let programFeedbacks                //feedbacks related to program
  let matchedFeedbacks                //feedbacks related to current page

  programFeedbacks = filterFeedbacksByProgramId(feedbacks.items, programId) //feedbacks related to current program

  matchedFeedbacks = matchFeedbacksByPath(programFeedbacks, currentPath) // matching current program feedbacks with page URL

  matchedFeedbacks.forEach(item => {     // check feedback and css_selector to put widget on page
    const selector = item.css_selector;

    waitForElement(selector, () => { // waiting DOM
      const elements = document.querySelectorAll(selector);

      elements.forEach((el) => {
        const uniqueWidgetId = uniqueId()
        const widget = document.createElement('sophia-feedback');
        widget.setAttribute('type', item.name);
        widget.setAttribute('cta', item.cta);
        widget.setAttribute('question', item.question);
        widget.setAttribute('placeholder', item.placeholder);
        widget.setAttribute('color', item.color);
        widget.setAttribute('data-id', item.name.replace(/ /g, "_") + uniqueWidgetId);
        widget.setAttribute('data-index', uniqueWidgetId);

        el.appendChild(widget)
      })
    })
  })
}

// Matches program feedbacks to the current page path with picomatch globs.
// Extracted + exported so the glob-matching contract and ReDoS resilience
// (picomatch >= 4.0.4, CVE-2026-33671) can be unit-tested. See injector.spec.js.
export function matchFeedbacksByPath(feedbacks, currentPath) {
  return feedbacks.filter((item) => {
    try {
      return picomatch(item.path)(currentPath)
    } catch {
      // Non-blocking: a malformed/empty glob in attacker-influenceable config
      // must not break feedback injection for every user — skip the bad pattern.
      return false
    }
  })
}

export function filterFeedbacksByProgramId(feedbacks, programId) {
  return feedbacks.filter((item) => {
    return item.all_programs === true || item.program_ids.includes(programId);
  })
}

function waitForElement(selector, callback) {
  if (document.querySelector(selector)) {
    return callback();
  }

  const observer = new MutationObserver(() => {
    if (document.querySelector(selector)) {
      observer.disconnect();
      callback();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

$(() => {
  if (SOPHIA.loggedIn()) {
    initFeedbackInjector()
  }
})
